// The chat agents close an answer with a chunk carrying the critic's scores, or `critic_error`
// (with null scores) when the critic failed. It feeds the trust score popup, not the answer body.
export const isTrustScoreChunk = (chunk) => chunk?.critic_scores !== undefined;

// Stored critic scores (BCO_MASTER.TRUST_SCORE_* and BCO_COMBINATION_MAPPING.AGENT_EVAL_SCORE)
// arrive as an array or as its JSON string. Anything the critic has not scored comes back empty.
export const storedAgentTrustScores = (stored) => {
    let scores = stored;
    if (typeof scores === "string") {
        try {
            scores = JSON.parse(scores);
        } catch {
            scores = null;
        }
    }
    return Array.isArray(scores) ? scores : [];
};
